import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Card, Form, Input, Select, Spin, message, Popover } from 'antd'
import { getResourceForImport } from '../../appRedux/actions/Organisation'
import { fuelImport } from '../../appRedux/actions/Fuel'
import { faviconDynamicFunction } from '../../util/methods'

const { Option } = Select

const BulkFuelImport = ({
    match,
    loading,
    authUser,
    data,
    getResourceForImport,
    fuelImport,
    form
}) => {
    const [file, setFile] = useState(null)
    const { getFieldDecorator } = form

    // useEffect(() => {
    //     console.log('data****:', data)
    // }, [data])

    useEffect(() => {
        getResourceForImport()
    }, [])

    const onFileUpload = e => {
        e.preventDefault()
        form.validateFields((err, values) => {
            if (err) {
                return console.log(err)
            }
            if (values.organisation && file) {
                handleFuelImport({
                    organisation: values.organisation,
                    file: file
                })
            }
            form.resetFields()
        })
    }

    const onFileChange = e => {
        setFile(e.target.files[0])
    }

    const handleFuelImport = (payload) => {
        fuelImport(payload)
    }

    const templateContent = (
        <div>
            <p>CSV file template</p>
            <Button size={'small'} onClick={() => {
                window.open('../csv_template/FuelImportTemplate.csv', '_blank')
            }}>Download</Button>
        </div>
    )

    faviconDynamicFunction(authUser)

    return (
        <Spin spinning={loading}>
            <Card className={`gx-card-metrics`}>
                <span>
                    <h2>Bulk Fuel Data Import</h2>
                    <Popover content={templateContent} title="" trigger="click">
                        <Button type="default" icon="download" size={'small'}>Template</Button>
                        <small>Date will be in the format of <span style={{ color: 'red' }}>DD/MM/YY hh:mm:ss</span></small>
                    </Popover>
                </span>
                <div style={{ marginTop: '30px', marginLeft: '2%', width: '50%' }}>
                    <Form onSubmit={onFileUpload}>
                        <Form.Item label="Select Organisation">
                            {getFieldDecorator("organisation", {
                                rules: [{ required: true, message: `Organisation is required!` }],
                            })(
                                <Select
                                    mode='single'
                                    showSearch
                                    allowClear
                                    placeholder={'Select Organisation'}
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {data && data.length && data.map(org =>
                                        <Option key={org._id} value={org._id}>{org.name}</Option>
                                    )}
                                </Select>
                            )}
                        </Form.Item>

                        <Form.Item label={'File:'}>
                            {getFieldDecorator("file", {
                                rules: [{ required: true, message: `File is required!` }],
                            })(
                                <Input
                                    type="file"
                                    accept=".csv"
                                    onChange={onFileChange}
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                className="gx-mb-0"
                                htmlType="submit"
                                loading={loading}
                            >
                                Import
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Card>
        </Spin>
    )
}

const mapStateToProps = ({ organisation, commonData }) => {
    return {
        loading: commonData.loading,
        data: organisation.resources,
        authUser: commonData.authUser
    }
}

export default connect(mapStateToProps, {
    getResourceForImport,
    fuelImport
})(Form.create()(BulkFuelImport)) 